import { checkIsManifestLinearType } from './playback-type';
import { PlaybackTypeKey } from './utils.enums';
export { PlaybackTypeKey } from './utils.enums';
export function identifyPlaybackTypeKey(playbackType) {
    var isLinearStream = checkIsManifestLinearType(playbackType);
    if (isLinearStream) {
        return PlaybackTypeKey.LINEAR;
    }
    return PlaybackTypeKey.VOD;
}

//# sourceMappingURL=playback-vendor-relation.js.map